import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component =
    | 'MyPets'
    | 'AboutYouForm'
    | 'ChangePasswordForm'
    | 'CompleteProfileBanner'
    | 'CompleteProfileStepper'
    | 'VerifyEmailAlert';

/**
 * Errors related to the About You page
 */
export const Errors = createErrors<Page, Component>('AboutYou')({
    CompleteProfileBanner: {
        LoadFailed: {
            severity: 'MEDIUM',
            message: 'Failed to load profile completion stepper banner.',
        },
    },
    CompleteProfileStepper: {
        LoadFailed: {
            severity: 'MEDIUM',
            message: 'Failed to load profile completion stepper.',
        },
        SubmitFailed: {
            severity: 'MEDIUM',
            message: 'Failed to submit profile completion stepper step.',
        },
    },
    MyPets: {
        // TODO: Add different for ADD and EDIT pet
        SubmitFailed: {
            severity: 'MEDIUM',
            message: 'Failed to add / edit pet',
        },
        RemovePetFailed: {
            severity: 'MEDIUM',
            message: 'Failed to remove pet',
        },
        FetchPetsFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch pets',
        },
        UploadPetPhotoFailed: {
            severity: 'MEDIUM',
            message: 'Failed to upload pet photo',
        },
        UpdatePetStatusFailed: {
            severity: 'MEDIUM',
            message: 'Failed to update pet status',
        },
        PetImageLoadFailed: {
            severity: 'LOW',
            message: 'Failed to load pet image',
        },
    },
    AboutYouForm: {
        SaveSelectedAddressFailed: {
            severity: 'MEDIUM',
            message: 'Failed to save selected address',
        },
        GetUserDataFailed: {
            severity: 'MEDIUM',
            message: 'Failed to get user data',
        },
        EmailUniqueValidationFailed: {
            severity: 'MEDIUM',
            message: 'Failed to verify email uniqueness (account validations)',
        },
    },
    ChangePasswordForm: {
        ChangePasswordFailed: {
            severity: 'HIGH',
            message: 'Failed to change password',
        },
    },
    ChangeEmailSection: {
        ChangeEmailRedirectFailed: {
            severity: 'HIGH',
            message: 'Failed to redirect to the Auth0 change email flow',
        },
    },
    VerifyEmailAlert: {
        ResendEmailFailed: {
            severity: 'MEDIUM',
            message: 'Failed to resend verification email',
        },
    },
});
